"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsTrue = void 0;
var IsTrue = function () { }; // for type assertion, normally use with IsSame or IEqual
exports.IsTrue = IsTrue;
